export default "__VITE_ASSET__UTePR4eg__"